function isEmptyObject(object) {
  return Object.values(object).length == 0
}

export default { isEmptyObject }